import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { formatDate } from '@angular/common';

export function getDateFromNgbDate(ngbDate?: NgbDate) {
    if (ngbDate) {
      return new Date(
        ngbDate.year, ngbDate.month - 1, ngbDate.day, 0, 0, 0, 0
      );
    }
    else return undefined;
}

export function getNgbDate(range?: number | undefined): NgbDate | any {
    let year: number = new Date().getFullYear() + (range ?? 0);
    let month: number = new Date().getMonth() + 1;
    let day: number = new Date().getDate();
    return new NgbDate(year, month, day);
}

export function getNgbDateFromDate(date?: Date): NgbDate | undefined {
    if (!date) return undefined;
    date = new Date(date);
    return new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
}


export function adjustForTimezone(date: Date): Date {
    var timeOffsetInMS: number = date.getTimezoneOffset() * 60000;
    timeOffsetInMS = timeOffsetInMS < 0 ? -timeOffsetInMS : timeOffsetInMS;
    date.setTime(date.getTime() + timeOffsetInMS);
    return date
}

export function hoursFromDate(date: Date | number, activeLang: string): string | undefined {
    return new Date(date).toLocaleTimeString(activeLang, {
        hour: '2-digit',
        minute: '2-digit',
    }).split(" ").at(0)
}

export function localizedDateString(value: any, format = 'short', lang = 'en'): string {
    if (lang === 'en') {
        lang = 'en-GB';
    }
    if (lang === 'sr' || lang === 'bs') {
        lang = "sr-Latn";
    }
    if (!value || isNaN(new Date(value).getTime())) {
        return '';
    }

    return formatDate(value, format, lang);
};
